import {
  getPageBrand,
  isPageAllowedForBrandAccess,
} from '../config/page-brand-registry'

/**
 * Effective page access: RBAC grant (my-pages) and user brand_access ceiling (Option A).
 */
export function canAccessPageForUser(
  pageKey: string,
  brandAccess: string | null | undefined,
  allowedPages: readonly string[],
): boolean {
  if (!allowedPages.includes(pageKey)) {
    return false
  }
  return isPageAllowedForBrandAccess(pageKey, brandAccess)
}

export function canUseAiClaimsProduct(
  brandAccess: string | null | undefined,
): boolean {
  return brandAccess === 'aiclaims' || brandAccess === 'both'
}

export function resolvePageBrandForCatalog(
  pageKey: string,
  catalogBrand?: string | null,
): ReturnType<typeof getPageBrand> {
  if (
    catalogBrand === 'wysehub' ||
    catalogBrand === 'aiclaims' ||
    catalogBrand === 'global'
  ) {
    return catalogBrand
  }
  return getPageBrand(pageKey)
}
